(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/login-paper.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/login-paper.js');
'use strict';

const {
  ReactPaper: Paper
} = svs.ui;
const {
  GetEidLink
} = svs.playerLoginReact.sharedComponents;
const ModeShiftLink = svs.playerLoginReact.sharedComponents.ModeShiftLink;
const {
  loginType,
  frejaeIdPollType
} = svs.playerLoginReact.constants;
const LoginPaper = _ref => {
  let {
    children
  } = _ref;
  const isBankId = ReactRedux.useSelector(state => state.playerloginreact.playerLoginType) === loginType.BANKID;
  const currentFrejaEidPollType = ReactRedux.useSelector(state => state.playerloginreact.frejaeIdPollType);
  return React.createElement(Paper, {
    className: "padding-h-2 padding-v-1 fc-navy margin-sm-3"
  }, children, React.createElement("div", {
    className: "u-flex padding-top-1"
  }, !isBankId && currentFrejaEidPollType !== frejaeIdPollType.SPINNER_POLL && React.createElement(ModeShiftLink, null), React.createElement(GetEidLink, null)));
};
svs.playerLoginReact.sharedComponents.LoginPaper = LoginPaper;

 })(window);